import type { ProfileAdmission } from '@/types/customer/customer.types';
import { computed, readonly, ref } from 'vue';

const admission = ref<ProfileAdmission | null>(null);

export default function useCustomerAdmission() {
  const isInactive = computed<boolean>(() => admission.value?.status === 'inactive' || false);

  const expiration = computed<ProfileAdmission['expiration']>(() =>
    admission.value?.expiration || null);

  function setAdmission(data: ProfileAdmission | null) {
    admission.value = data;
  }

  return {
    admission: readonly(admission),
    expiration,
    isInactive,
    setAdmission,
  };
}
